<template>
  <v-container fluid class="config-layout pa-4">
    <v-row>
      <!-- Panel derecho -->
      <v-col cols="10" class="right-panel">
        <!-- Proyecto horizontal o vertical -->
        <v-container>
          <v-row class="d-flex justify-center mt-4 justify-space-around">
            <my-tooltip text="En los proyectos horizontales no existe jerarquía de roles, todos los usuarios tienen libertad de acción" position="bottom">
              <v-col :class="['d-flex', 'flex-column', 'align-center', 'type-project-selector', this.$store.state.newProject.options.typeProject == 'horizontal' ? 'type-project-selector-selected' : null]" @click="setHorizontal">
                <animated-icons
                  src="https://animatedicons.co/get-icon?name=Team&style=minimalistic&token=9c840f28-8274-4ee6-b5b3-7707bde20ce4"
                  trigger="loop"
                  attributes='{"variationThumbColour":"#536DFE","variationName":"Two Tone","variationNumber":2,"numberOfGroups":2,"backgroundIsGroup":false,"strokeWidth":1,"defaultColours":{"group-1":"#000000","group-2":"#14B8A6FF","background":"#FFFFFF"}}'
                  height="125"
                  width="125"
                ></animated-icons>
                <span style="user-select: none">Horizontal</span>
              </v-col>
          </my-tooltip>
          <my-tooltip text="Puedes configurar a gusto las opciones del proyecto" position="bottom">
            <v-col :class="['d-flex', 'flex-column', 'align-center', 'type-project-selector', this.$store.state.newProject.options.typeProject == 'mixto' ? 'type-project-selector-selected' : null]" @click="this.$store.state.newProject.options.typeProject = 'mixto'">
              <animated-icons
                src="https://animatedicons.co/get-icon?name=Libraries&style=minimalistic&token=1782cb4f-47df-4194-8042-a7ff30ae5f52"
                trigger="loop"
                attributes='{"variationThumbColour":"#536DFE","variationName":"Two Tone","variationNumber":2,"numberOfGroups":2,"backgroundIsGroup":false,"strokeWidth":1,"defaultColours":{"group-1":"#000000","group-2":"#536DFE","background":"#FFFFFF"}}'
                height="125"
                width="125"
              ></animated-icons>
              <span style="user-select: none">Mixto</span>
            </v-col>
          </my-tooltip>
          <my-tooltip text="En los proyectos verticales existe jerarquía de roles, solo algunos usuarios tendrán libertad de acción" position="bottom">
            <v-col :class="['d-flex', 'flex-column', 'align-center', 'type-project-selector', this.$store.state.newProject.options.typeProject == 'vertical' ? 'type-project-selector-selected' : null]" @click="setVertical">
              <animated-icons
                src="https://animatedicons.co/get-icon?name=Gold&style=minimalistic&token=46faf108-8d5f-41de-b800-cee6ed496231"
                trigger="loop"
                attributes='{"variationThumbColour":"#536DFE","variationName":"Two Tone","variationNumber":2,"numberOfGroups":2,"backgroundIsGroup":false,"strokeWidth":1,"defaultColours":{"group-1":"#000000","group-2":"#14B8A6FF","background":"#FFFFFF"}}'
                height="125"
                width="125"
              ></animated-icons>
              <span style="user-select: none">Vertical</span>
            </v-col>
          </my-tooltip>
          </v-row>
        </v-container>

        <v-container v-if="!this.$store.state.newProject.options.isHorizontal">
          <v-switch
            class="mt-4"
            label="Votaciones para el acta dialógica"
            color="primary"
            v-model="this.$store.state.newProject.options.useVoting"
          ></v-switch>
        </v-container>

        <!-- Chat colaborativo -->
        <v-container class="d-flex flex-column">
          <v-switch
            class="mt-4"
            label="Chat colaborativo"
            color="primary"
            v-model="this.$store.state.newProject.options.useChat"
          ></v-switch>

          <!-- Kanban -->
          <v-switch
            class="mt-4"
            label="Kanban"
            color="primary"
            v-model="this.$store.state.newProject.options.useKanban"
          ></v-switch>

          <!-- Ágil / Scrum -->
          <v-switch
            class="mt-4"
            label="Ágil / Scrum"
            color="primary"
            v-model="this.$store.state.newProject.options.isAgile"
          ></v-switch>

          <!-- Subproyectos -->
          <v-switch
            class="mt-4"
            label="Subproyectos"
            color="primary"
            v-model="this.$store.state.newProject.options.hasSubprojects"
          ></v-switch>

          <!-- Subproyectos a partir de compromiso -->
          <v-switch
            class="mt-4"
            label="Subproyectos a partir de compromiso"
            color="primary"
            v-model="this.$store.state.newProject.options.hasSubprojectsFromCommitment"
          ></v-switch>
        </v-container>

      </v-col>
    </v-row>

    <v-row justify="space-between" class="d-flex mt-4">
      <!-- Atrás -->
      <v-col cols="5">
      <v-btn color="red" @click="cambiarVista(1)" class="animated-button">Atrás</v-btn>
      </v-col>

      <!-- Continuar -->
      <v-col cols="5">
      <v-btn color="primary" @click="cambiarVista(3)" class="animated-button">Continuar</v-btn>
      </v-col>
    </v-row>

    <!-- <button @click="test">test</button> -->

    <!-- Snackbar para mensajes de error -->
    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      bottom
      color="error"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import MyTooltip from '../generic/MyTooltip.vue';
export default {
  name: "ProjectConfigLayout",
  components: {
    MyTooltip
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",

      // Opciones de configuración
      options: {
        useChat: true,
        isAgile: false,
        useKanban: true,
        typeProject: 'mixto',
        useVoting: false,
      }
    };
  },
  methods: {
    cambiarVista(number) {
      this.$store.state.cms_view = number;
    },
    setHorizontal() {
      this.$store.state.newProject.options.isHorizontal = true;

      this.$store.state.newProject.options.useVoting = false;
      this.$store.state.newProject.options.useChat = true;
      this.$store.state.newProject.options.useKanban = true;
      this.$store.state.newProject.options.isAgile = true;
      this.$store.state.newProject.options.typeProject = 'horizontal';
      this.$store.state.newProject.options.hasSubprojectsFromCommitment = false;
    },
    setVertical(){
      this.$store.state.newProject.options.isHorizontal = false;

      this.$store.state.newProject.options.useVoting = true;
      this.$store.state.newProject.options.useChat = false;
      this.$store.state.newProject.options.useKanban = true;
      this.$store.state.newProject.options.isAgile = false;
      this.$store.state.newProject.options.typeProject = 'vertical';
      this.$store.state.newProject.options.hasSubprojectsFromCommitment = true;
    }
  },
};
</script>

<style scoped>
.config-layout {
  height: 100vh;
  overflow-x: hidden;
}
.left-panel {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 30px;
}
.step-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}
.step-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ccc;
  color: #fff;
  text-align: center;
  line-height: 24px;
  margin-right: 10px;
}
.step-text {
  font-weight: 500;
}
.step-line {
  width: 2px;
  background-color: #ccc;
  margin: 0 auto;
  flex-shrink: 0;
  height: 60px;
}
.right-panel {
  padding: 20px;
}
.big-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}
.big-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.circle-and-fields {
  margin-bottom: 20px;
}
.input-group-with-line {
  position: relative;
  display: flex;
  gap: 16px;
  padding: 10px 0;
}
.v-text-field,
.v-textarea {
  margin-bottom: 0;
}

.type-project-selector{
  cursor: pointer;
  border-radius: 5%;
}


.type-project-selector:hover{
  border: 2px solid #14B8A6;
}

.type-project-selector-selected{
  background-color: #14b8a563;
}

.animated-button {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
</style>
